/**
 * AnnouncementsCtrl controller
 */

import { REMINDER_TYPE, PN_STATUSES } from 'app/core/constants'
import { add, remove } from 'app/helpers/entity'
import moment from 'moment'

// controller mixins
AnnouncementsCtrl.mixes = [
  ['m2mCtrlMixin', 'announcement', 'subscribers'],
  'onOffCtrlMixin'
]

/**
 * AnnouncementsCtrl controller
 *
 * @class AnnouncementsCtrl
 * @memberof mwApp/packages
 * @see mwApp/packages
 * @mixes mwApp/common.mixin:m2mCtrlMixin
 * @mixes mwApp/common.mixin:onOffCtrlMixin
 * @mixes mwApp/common.mixin:tabsCtrlMixin
 *
 * @ngdoc controller
 * @name mwApp/packages.controller:AnnouncementsCtrl
 */
/* @ngInject */
export default function AnnouncementsCtrl ($scope, $timeout, $uibModal, Announcement, PushNotification, SubscriberDTO, Subscriber, Subscription, pckg, inapp, authSvc, alertSvc) {
  var vm = this
  vm.mixes = authSvc.hasEnabledFlag('FEATURE_NORA_UI_PUSH_NOTIFICATIONS_ENABLED')
    ? [['tabsCtrlMixin', '', 'reminders', 'toa', 'disabled', 'pushNotifications']]
    : [['tabsCtrlMixin', '', 'reminders', 'toa', 'disabled']]

  /**
   * Loader indicator
   *
   * @type {boolean}
   */
  $scope.loading = true

  /**
   * Promise stack
   *
   * @type {Array}
   */
  vm.loaderStack = []
  vm.pnStatuses = PN_STATUSES

  vm.pn_statuses = ['SENT_OUT', 'PENDING', 'FAILED', 'DELETED']

  /**
   * Package/Network
   *
   * @memberof mwApp/packages.controller:AnnouncementsCtrl
   * @type {models.Network}
   */
  vm.pckg = pckg

  /**
   * Default Package for in-app registration
   *
   * @memberof mwApp/packages.controller:AnnouncementsCtrl
   * @type {number}
   */
  vm.inappNetworkId = !inapp?.multiorgEnabled && inapp?.inAppRegistrationSettings?.enabled && inapp.inAppRegistrationSettings.network?.id

  /**
   * Default Package for Guest Mode
   *
   * @memberof mwApp/packages.controller:SubscriptionSettingsCtrl
   * @type {number}
   */
  vm.guestNetworkId = !inapp?.multiorgEnabled && inapp?.guestModeSettings?.enabled && inapp.guestModeSettings.network?.id

  // package id
  const networkId = pckg.id

  Subscription.loadAll({ networkId }).to(vm.subscriptions = [])

  /**
   * Reminder types
   *
   * @memberof mwApp/packages.controller:AnnouncementsCtrl
   * @type {Object}
   */
  vm.reminder_type = REMINDER_TYPE

  /**
   * Announcement
   *
   * @memberof mwApp/packages.controller:AnnouncementsCtrl
   * @type {models.Announcement}
   */
  var announcement = vm.announcement = new Announcement({
    announcementType: 'Announcement',
    networkId
  })

  /**
   * Activation TOA Announcement
   *
   * @memberof mwApp/packages.controller:AnnouncementsCtrl
   * @type {models.Announcement}
   */
  vm.activationToaAnnouncement = null

  /**
   * Announcement for disabled subscribers
   *
   * @memberof mwApp/packages.controller:AnnouncementsCtrl
   * @type {models.Announcement}
   */
  vm.disabledAnnouncement = null
  vm.pendingAnnouncement = null
  vm.suspendedAnnouncement = null

  // load extra
  vm.loaderStack.push(Announcement.loadExtra({ networkId }).then(res => {
    return res
  })
    .to(vm)
    .then(
      () => {
        // save initial disabled and toa announcements
        vm.initialDisabledAnnouncement = angular.copy(vm.disabledAnnouncement)
        vm.initialPendingAnnouncement = angular.copy(vm.pendingAnnouncement)
        vm.initialSuspendedAnnouncement = angular.copy(vm.suspendedAnnouncement)
        vm.initialActivationToaAnnouncement = angular.copy(vm.activationToaAnnouncement)
      }
    ))

  // load past announcements
  vm.loaderStack.push(Announcement.loadAll({ networkId })
    .to(vm.announcements = []))

  /**
   * Check loader
   */
  Promise.all(vm.loaderStack)
    .then(() => {
      $scope.loading = false
    })

  /**
   * Get VODs from backend
   *
   * @memberof mwApp/vods.controller:VodsCtrl
   * @param {Object} tableState - smart table state object
   */
  vm.getPushNotifications = function (tableState) {
    if (!tableState.sort.predicate) {
      tableState.sort.predicate = 'createdTime'
      tableState.sort.reverse = false
    }
    PushNotification.loadSmartPN(tableState, { networkId })
      .then(
        data => {
          vm.pushNotifications = []
          data.content.forEach(pn => vm.pushNotifications.push(new PushNotification({ ...pn, networkId })))
          vm.isFound = !!vm.pushNotifications.length
          vm.pendingTimer = 0

          for (const pn of vm.pushNotifications) {
            if (pn.status === 'PENDING') {
              vm.pendingTimerMax = 36000000 // 10hrs - max session duration
              const diff = -(moment().diff(pn.startTime))
              if (diff > -100000 && diff < vm.pendingTimerMax && (!vm.pendingTimer || diff < vm.pendingTimer)) {
                vm.pendingTimer = diff > 50000 ? diff : 5000
              }
            }
          }

          if (vm.pendingTimer !== 0) {
            vm.timerId = $timeout(() => {
              $scope.$broadcast('refreshTable')
            }, vm.pendingTimer)
          }

          $scope.loading = false
        }
      )
  }

  vm._selectSubscriber = function (subscr, $select) {
    if (subscr.id === -1) {
      vm.resetSubscribers()
      $select.close()
    } else {
      vm.selectSubscriber(subscr)
    }
  }

  /**
   * Search networks params with default values
   *
   * @memberof mwApp/packages.controller:AnnouncementsCtrl
   * @type {Object}
   */
  vm.defaultSubscribersSearchParams = {
    q: null,
    page: 0,
    count: 100,
    networks: vm.pckg.id,
    'sort-by': 'accountNumber',
    'sort-order': 'ASC'
  }

  vm.getSubscribers = function (search) {
    const params = vm.subscribersSearchParams = angular.copy(vm.defaultSubscribersSearchParams)
    params.q = search

    Subscriber._getSubscribers(angular.copy(params))
      .then((data) => {
        vm.subscribers = [{
          accountNumber: 'All Subscribers',
          id: -1
        }]

        vm.subscribers = vm.subscribers.concat(data.content.filter(subscriber => subscriber.devices.length && !vm.announcement.subscribers.find(s => s.id === subscriber.id)))
        params.last = data.last
        params.page = data.number
        vm.$isLoading = 0
      })
  }

  /**
   * Handler for scroll event of select list
   *
   * @param $select
   * @param event
   */
  vm.setByCallbackScroll = ($select, event) => {
    const { last } = vm.subscribersSearchParams
    if (!vm.$isLoading && !last && event.currentTarget.scrollTop >= (event.currentTarget.scrollHeight - event.currentTarget.clientHeight) * 0.6) {
      vm.$isLoading = 1
      const params = vm.subscribersSearchParams
      if (params.last) { return }
      params.page++
      Subscriber._getSubscribers(angular.copy(params))
        .then((data) => {
          vm.subscribers.push(...data.content.filter(subscriber => subscriber.devices.length))
          params.last = data.last
          params.page = data.number
          vm.$isLoading = 0
        })
    }
  }

  /**
   * Send announcement
   *
   * @memberof mwApp/packages.controller:AnnouncementsCtrl
   */
  vm.sendAnnouncement = function () {
    vm.setDisable()

    announcement._save(null, null, announcement.name + ' Announcement has been sent')
      .then(add(vm.announcements)(announcement))
      .then(vm.restoreAnnouncement)
      .finally(vm.unsetDisable)
  }

  /**
   * Restore announcement
   *
   * @memberof mwApp/packages.controller:AnnouncementsCtrl
   */
  vm.restoreAnnouncement = function () {
    // create new announcement stub and clear form
    announcement = vm.announcement = new Announcement({
      announcementType: 'Announcement',
      networkId
    })
    // restore subscribers
    vm.getSubscribers()
    // clear form validation
    vm.aform.$setPristine()
    vm.aform.$setUntouched()
  }

  /**
   * Cancel editing announcement
   *
   * @memberof mwApp/packages.controller:AnnouncementsCtrl
   */
  vm.cancel = function () {
    switch (vm.activeTabName) {
      case '': // restore announcement
        vm.restoreAnnouncement()
        break

      case 'toa': // restore toa
        angular.copy(vm.initialActivationToaAnnouncement, vm.activationToaAnnouncement)
        break

      case 'disabled': // restore disabled
        angular.copy(vm.initialDisabledAnnouncement, vm.disabledAnnouncement)
        angular.copy(vm.initialPendingAnnouncement, vm.pendingAnnouncement)
        angular.copy(vm.initialSuspendedAnnouncement, vm.suspendedAnnouncement)
    }
  }

  /**
   * Delete reminder
   *
   * @memberof mwApp/settings.controller:AnnouncementsCtrl
   * @param {models.Announcement} announcement
   */
  vm.deleteReminder = function (announcement) {
    vm.setDisable()

    announcement._delete()
      .then(remove(vm.announcements)(announcement))
      .finally(vm.unsetDisable)
  }
  /**
   * Delete reminder
   *
   * @memberof mwApp/settings.controller:AnnouncementsCtrl
   * @param {models.PushNotification} pn
   */
  vm.deletePushNotification = function (pn) {
    vm.setDisable()

    pn._delete()
      .then(() => {
        $scope.$broadcast('refreshTable')
      })
      .finally(vm.unsetDisable)
  }

  /**
   * Edit reminder
   *
   * @memberof mwApp/settings.controller:AnnouncementsCtrl
   * @function
   * @param {models.Announcement} announcement
   */
  vm.editReminder = null

  /**
   * Create reminder
   *
   * @memberof mwApp/settings.controller:AnnouncementsCtrl
   * @function
   * @param {models.Announcement} announcement
   */
  vm.addReminder = vm.editReminder = function (announcement) {
    var isNew = !announcement
    var initialAnnouncement = angular.copy(announcement) // initial state
    $uibModal.open({
      templateUrl: 'components/packages/views/addReminder.html',
      controller: 'AddReminderCtrl as vm',
      animation: false,
      size: 'lg',
      resolve: {
        announcement: function () {
          return !isNew
            ? announcement
            : (
              new Announcement({
                announcementType: 'Reminder',
                reminderType: 'All',
                networkId
              })
            )
        }
      }
    }).result
      .then(
        function close (announcement) {
          if (isNew) {
            vm.announcements.push(announcement)
          }
        },
        function dismiss () {
          if (!isNew) {
            angular.copy(initialAnnouncement, announcement) // restore announcement
          }
        }
      )
  }

  /**
   * Create Push Notification
   *
   * @memberof mwApp/settings.controller:AnnouncementsCtrl
   * @function
   * @param {models.PushNotification} pushNotification
   */
  vm.addPushNotification = vm.editPushNotification = function (pushNotification) {
    var isNew = !pushNotification
    var initialPushNotification = angular.copy(pushNotification) // initial state
    $uibModal.open({
      templateUrl: 'components/packages/views/addPushNotification.html',
      controller: 'AddPushNotificationCtrl as vm',
      animation: false,
      size: 'lg',
      resolve: {
        pn: function () {
          return !isNew
            ? PushNotification.load({ id: pushNotification.id, networkId }).then((res) => {
              return new PushNotification({ ...res, networkId })
            })
            : (
              new PushNotification({
                networkId
              })
            )
        },
        isCopy: false,
        pckg: vm.pckg,
        subscriptions: function () {
          return vm.subscriptions
        }
      }
    }).result
      .then(
        function close () {
          $scope.$broadcast('refreshTable')
        },
        function dismiss () {
          if (!isNew) {
            angular.copy(initialPushNotification, pushNotification) // restore announcement
          }
        }
      )
  }

  vm.copyPushNotification = function (pushNotification) {
    $uibModal.open({
      templateUrl: 'components/packages/views/addPushNotification.html',
      controller: 'AddPushNotificationCtrl as vm',
      animation: false,
      size: 'lg',
      resolve: {
        pn: function () {
          return PushNotification.load({ id: pushNotification.id, networkId }).then((res) => {
            return new PushNotification({ ...res, networkId })
          })
        },
        isCopy: true,
        pckg: vm.pckg,
        subscriptions: function () {
          return vm.subscriptions
        }
      }
    }).result
      .then(
        function close () {
          $scope.$broadcast('refreshTable')
        }
      )
  }

  $scope.$on('$destroy', function () {
    if (vm.timerId) {
      $timeout.cancel(vm.timerId)
    }
  })

  /**
   * Save announcement for disabled subscribers
   *
   * @memberof mwApp/packages.controller:AnnouncementsCtrl
   */
  vm.saveDisabledAnnouncement = function (form) {
    vm.setDisable()
    const promisses = [vm.disabledAnnouncement._save(null, null, null)]
    if (authSvc.hasEnabledFlag('FEATURE_SUBSCRIBER_STATUS_ANNOUNCEMENT_ENABLED')) {
      promisses.push(
        vm.pendingAnnouncement._save(null, null, null),
        vm.suspendedAnnouncement._save(null, null, null))
    }
    Promise.all(promisses).then(() => {
      alertSvc.alert('Messages saved', 'success')
      form.$setPristine()
    })
      .finally(vm.unsetDisable)
    // vm.disabledAnnouncement
    //   ._save(null, null, vm.disabledAnnouncement.name + ' message saved')
    //   .then(() => { form.$setPristine() })
    //   .finally(vm.unsetDisable)
  }

  /**
   * Save Activation TOA announcement
   *
   * @memberof mwApp/packages.controller:AnnouncementsCtrl
   */
  vm.saveTOA = function (form) {
    vm.setDisable()

    vm.activationToaAnnouncement
      ._save(null, null, 'Activation TOA message saved')
      .then(() => {
        angular.copy(vm.activationToaAnnouncement, vm.initialActivationToaAnnouncement)
        form.$setPristine()
      })
      .finally(vm.unsetDisable)
  }
}
